<template>
  <el-dialog
    title="预算分配"
    :visible="visible"
    :before-close="closeDialog"
    v-loading="loading"
    width="500px">
    <div style="text-align: center; font-size: 20px">
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="省份名称"
                          prop="name">
              {{province.provincename}}
            </el-form-item>
          </div>
          <div class="medium">
            <el-form-item label="可分配预算"
                          prop="name">
              {{total}}
            </el-form-item>
          </div>
          <div class="medium">
            <el-form-item label="调整预算"
                          prop="assigned_budget">
              <el-input v-model="form.assigned_budget"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">确定
          </el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    visible: Boolean,
    province: {
      type: Object,
      default: function () {
        return {}
      },
    },
    remainBudgetNum: Number
  },
  data () {
    return {
      id: 0,
      loading: false,
      form: {
        assigned_budget: '',
      },
    }
  },
  computed: {
    total () {
      let total = parseFloat(this.province.assigned_budget) + parseFloat(this.remainBudgetNum)
      return _.round(total, 2)
    }
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    async onSubmit () {
      this.loading = true
      let params = {assigned_budget: this.form.assigned_budget, projectid: this.province.projectid, provinceid: this.province.provinceid, id: this.province.projectid}
      await request.alert('editExecutiveBudget', params).then((res) => {
        this.$message.success('预算分配成功')
        this.$emit('closeDialogRefresh')
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    closeDialog () {
      this.$refs.form.resetFields()
      this.$emit('closeDialog')
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/executive-budget/pages/ExecutiveBudgetDialog.vue